export enum ESelection {
    ALL_STORES = 'ALL_STORES',
    SOME_STORES = 'SOME_STORES',
}
